import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// components
import Btn from '../../components/Btn';

// actions
import { editPlaces } from '../../reducers/Places/actions';

const EditBtnPropTypes = {
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have successfully returned from service
  dispatchEditPlaces: PropTypes.func.isRequired, // Captures current state and toggles edit mode on
  editing: PropTypes.bool.isRequired, // If the trip details are being edited after directions loaded
  currentState: PropTypes.shape({}).isRequired, // The app state before user began editing their trip details
};

const EditBtnDefaultProps = {};

class EditBtn extends Component {
  constructor(props) {
    super(props);

    this.toggleEditMode = this.toggleEditMode.bind(this);
  }

  toggleEditMode() {
    const { currentState, dispatchEditPlaces } = this.props;
    dispatchEditPlaces(currentState);
  }

  render() {
    const { isMobile, directionsLoaded, editing } = this.props;

    if (isMobile && directionsLoaded && !editing) {
      return (
        <Btn styles={classNames('edit-btn')} handleClick={this.toggleEditMode}>
          <i className="tsla-icon_map--edit" />
        </Btn>
      );
    }

    return null;
  }
}

EditBtn.propTypes = EditBtnPropTypes;

EditBtn.defaultProps = EditBtnDefaultProps;

const mapStateToProps = state => ({
  isMobile: state.App.isMobile,
  directionsLoaded: state.Directions.directionsLoaded,
  editing: state.Places.editing,
  currentState: state,
});

const mapDispatchToProps = dispatch => ({
  // eslint-disable-next-line arrow-parens
  dispatchEditPlaces: currentState => {
    dispatch(editPlaces(currentState));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditBtn);
